import { __assign, __rest } from "tslib";
import * as React from 'react';
import { getMonthDetails, getPureDate, getToday, toDateString, } from './internal/common';
import { CalendarPopup } from './internal/CalendarPopup';
import { useOutsideClick } from '../../hooks';
var absMinDate = new Date(-93692595208000);
var absMaxDate = new Date(253402210800000);
export var DateField = function (_a) {
    var onChange = _a.onChange, error = _a.error, label = _a.label, value = _a.value, readOnly = _a.readOnly, _b = _a.defaultValue, defaultValue = _b === void 0 ? new Date() : _b, children = _a.children, props = __rest(_a, ["onChange", "error", "label", "value", "readOnly", "defaultValue", "children"]);
    var minDate = getPureDate(props.minDate || absMinDate);
    var maxDate = getPureDate(props.maxDate || absMaxDate);
    var today = getToday();
    var el = React.useRef(undefined);
    var controlled = React.useMemo(function () { return value !== undefined; }, []);
    var initial = getPureDate(controlled ? value : defaultValue);
    var _c = React.useReducer(function (state, values) {
        var force = values.force, update = __rest(values, ["force"]);
        var newState = __assign(__assign({}, state), update);
        if (!force && newState.selectedDay !== state.selectedDay) {
            var value_1 = newState.selectedDay;
            setTimeout(function () { return onChange === null || onChange === void 0 ? void 0 : onChange(value_1); });
        }
        if (controlled && !force) {
            newState.selectedDay = state.selectedDay;
            newState.input = state.input;
        }
        return newState;
    }, {
        valid: true,
        input: toDateString(initial),
        month: initial.getUTCMonth(),
        year: initial.getUTCFullYear(),
        monthDetails: [],
        selectedDay: initial,
        showCalendar: false,
    }, function (state) { return (__assign(__assign({}, state), { monthDetails: getMonthDetails(initial.getUTCFullYear(), initial.getUTCMonth()) })); }), state = _c[0], dispatch = _c[1];
    var openCalendar = React.useCallback(function () { return dispatch({ showCalendar: true }); }, []);
    React.useEffect(function () {
        var selectedDay = getPureDate(value || defaultValue);
        if (state.selectedDay !== selectedDay) {
            dispatch({
                valid: true,
                selectedDay: selectedDay,
                input: toDateString(selectedDay),
                force: true,
            });
        }
    }, [controlled ? value : undefined]);
    var handleClickOutsideCalendar = React.useCallback(function () {
        dispatch({ showCalendar: false });
    }, []);
    useOutsideClick(el, handleClickOutsideCalendar);
    var change = React.useCallback(function (e) {
        var fullDate = getPureDate(e.target.value);
        var invalid = isNaN(fullDate.valueOf()) || fullDate > maxDate || fullDate < minDate;
        dispatch({
            valid: !invalid,
            selectedDay: invalid ? undefined : fullDate,
            input: e.target.value,
        });
    }, [props.minDate, props.maxDate]);
    return (React.createElement("div", { ref: el, className: "form-group" },
        React.createElement("input", { className: "form-control".concat(!error && state.valid ? '' : ' error'), type: "text", readOnly: readOnly, placeholder: "YYYY-MM-DD", value: state.input, onChange: change, onFocus: openCalendar }),
        label && React.createElement("label", { className: "text-floating" }, label),
        React.createElement("i", { className: "fas fa-calendar date-picker-icon", onClick: openCalendar }),
        children,
        !readOnly && state.showCalendar && (React.createElement(CalendarPopup, { state: state, min: minDate, max: maxDate, today: today, dispatch: dispatch }))));
};
//# sourceMappingURL=index.js.map